/**
 * @ngdoc component
 * @name  common.store.component:ItxStoreLocator
 * @requires $scope,
 * @requires $rootScope, 
 * @requires ngDialog, 
 * @requires ItxUtilsFct, 
 * @requires ItxStoreLocatorSvc,
 * @requires ItxScreenSizeSvc, 
 * @requires ItxConstants, 
 * @requires ItxLoaderFct, 
 * @requires $timeout, 
 * @requires imLocatorService
 * @requires common.store.service:FavouriteStoreService
 * 
 * @param {number} storeId Store id
 * @paramS   searchType
 * @param {function} closeDialog Close dialog event
 * @paramS   isPopup
 * @paramS   selectedSizes
 * @param {boolean}  action action to make
 * @param  {function} onSelectStore Tell to the parent component that a store has been selected
 * @paramS   checkEstafeta
 * @paramS   callButton
 * @param {boolean}   receiveEcommerce if receive ecommerce
 * @param {boolean}  showBlockedMaxPackage if max package has been reached 
 * @description
 * # *** IMPORTANT ***
 * PLEASE REFACTOR THIS COMPONENT
 *
 * 
 * # Overview
 * Store locator component. Modal used in tunnel and product view to show the stores availables to pickup the items.
 * Also showed in the stores pages. 
 * This component will be displayed in different flavours, as modal (in the tunnel) or as regular component in the store locator page.
 * 
 * 
 * # Main
 * - List store's close to the user location, with distance, hours and address information, and show them in the map.
 * - Select store, dropppoint or packstation to pickup the order.
 * - Add store to the favourite's user list. Also allow to delete it.
 * - Filter stores by City and Zip Code
 * 
 * # Used in the following pages:
 * - {@link store.component:ItxStoreLocatorPage StoreLocatorPage}
 * - Tunnel
 * - Product View
*/
// jshint ignore:start
(function () {

    'use strict';

    var ItxStoreLocatorCmp = {
        bindings: {
            storeId: '<',
            searchType: '<',
            closeDialog: '&',
            isPopup: '<',
            selectedSizes: '<',
            action: '<',
            onSelectStore: '&',
            checkEstafeta: '<',
            callButton: '<',
            receiveEcommerce: '<',
            showBlockedMaxPackage: '<'
        },
        controller: ItxStoreLocatorCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'store-locator.component.html'
    };

    ItxStoreLocatorCmpCtrl.$inject = [
                                    '$scope',
                                    '$rootScope',
                                    'ngDialog',
                                    'ItxUtilsFct',
                                    'ItxStoreLocatorSvc',
                                    'ItxScreenSizeSvc',
                                    'ItxConstants',
                                    'ItxLoaderFct',
                                    '$timeout',
                                    'imLocatorService',
                                    'FavouriteStoreService',
                                    'StoreConfigurationService',
                                    'ItxTranslateSvc',
                                    'logger',
                                    'CmsConfigSvc'];

    function ItxStoreLocatorCmpCtrl($scope,
                                    $rootScope, 
                                    ngDialog, 
                                    ItxUtilsFct, 
                                    ItxStoreLocatorSvc,
                                    ItxScreenSizeSvc, 
                                    ItxConstants, 
                                    ItxLoaderFct, 
                                    $timeout, 
                                    imLocatorService,
                                    FavouriteStoreService,
                                    StoreConfigurationService,
                                    ItxTranslateSvc,
                                    logger,
                                    CmsConfigSvc) {
        var _this = this;
        _this.mapsLoadedOk = false;
        _this.baiduMarkerSize = 70;
        _this.baiduMarkerSizeSmall = 46;
        _this.myLocation = {};
        //The variables named as store referes to any kind of
        // point to pickup the order: store, packstation, droppoint
        _this.stores = [];
        _this.storeList = [];
        _this.selectedStore = null;
        _this.map = null;
        _this.user = inditex.iUserJSON;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        _this.ItxStoreLocatorSvc = ItxStoreLocatorSvc;
        _this.ItxLoaderFct = ItxLoaderFct;
        //Mexico itxdroppoint funcionality
        _this.states = null;
        _this.stateName = null;
        _this.municipalities = null;
        _this.firstLoadPage = true;
        _this.municipalityName = null;
        _this.colonies = null;
        _this.colonyName = null;
        _this.storesCountry = [];
        _this.storeNumber = inditex.iStoreJSON.iNumTiendas;
        _this.shippingDescription = inditex.iUserJSON.shopCart.shipping ? inditex.iUserJSON.shopCart.shipping.description : '';
        _this.useNewDroppointSearch = false;
        _this.isSearchPristine = true;
        _this.searchByUser = false;
        _this.searching = false;
        _this._initialSearchDone = false;
        _this.movingTimer = null;
        _this.pendingEvents = false;
        _this.storeMap = {};
        _this.useNormalIcons = true;
        _this.minZoom = 3;
        _this.iconChangeZoom = 9;
        _this.maxStoreCount = 0;
        _this.visibleStoreCount = 0;
        _this.showFavourites = false;
        _this.allFavourites = true;
        _this.showResults = false;
        _this.isGuestUser = inditex.iUserJSON.userType === joyr.constants.user.GUEST;
        _this.isInitialSearch = true;

        _this.imListView = true;

        _this.isFirefox = typeof InstallTrigger !== 'undefined';
        
        _this.isMobile = ItxScreenSizeSvc.is('xs,sm');

        _this.countryCode = inditex.iStoreJSON.countryCode;

        _this.isDroppointSearch = function () {
            return _this.ItxStoreLocatorSvc.isDroppointSearch();
        };

        _this.storeStateKey = [];
        _this.storeStateColor = {};
        _this.storeState = null;
        _this.storeStateKeyValue = [];
        
        // Translation texts.
        _this.text = _this.ItxStoreLocatorSvc.getTranslations(_this.searchType);

        _this.imIsDropPoint = _this.isDroppointSearch();

        
        _this.$onInit = function () {

            ItxLoaderFct.show();
            StoreConfigurationService.getConfiguration();
            ItxStoreLocatorSvc.setStep('list');
            ItxStoreLocatorSvc.setSearchType(_this.searchType);
            ItxScreenSizeSvc.when('xs,sm,md,lg', function () {
                _this.redrawMap();
            });
            
            _getStoreStatusProperties();

            _this.isBaidu = false;
            if (!_this.storeId && inditex.iParams.physicalStoreId && inditex.iParams.physicalStoreId.toString()) {
                _this.storeIdByParams = inditex.iParams.physicalStoreId.toString();
            }
            inditex.getXconfiguracionValue('ENABLED_NUM_PHYSICAL_STORES_BY_STORE', function (status, value) {
                _this.physicalStoreEnabled = parseInt(value);
                inditex.getXconfiguracionValue('MAX_NUM_PHYSICAL_STORES', function (status, value) {
                    _this.maxStoreNumber = parseInt(value);
                    _this.showSearchBar = _this.physicalStoreEnabled !== 1 || _this.storeNumber > _this.maxStoreNumber;
                });
            });
            
            _this.deliveryTimeStore = '7-8';
            inditex.getXconfiguracionValue('DELIVERY_TIME_STORE', function (status, value) {
                if (value) { _this.deliveryTimeStore = value; };
            });
            inditex.getXconfiguracionValue('BAIDU_MAPS_KEY', function (status, value) {
                inditex.getXconfiguracionValue('RADIUS_SEARCH_STORE', function (status, value) {
                    _this.radiusSearchStore = value || 100;
                    inditex.getXconfiguracionValue('MIN_STORE_SEARCH_STORE', function (status, value) {
                        _this.minStoreSearchStore = value || 10;
                        //inditex.iBaiduMapsKey = value;
                        _this.isBaidu = inditex.iStoreJSON.countryCode === 'CN' && inditex.iBaiduMapsKey;
                        inditex.initMaps = _this.isBaidu ?
                            inditex.initBaiduMaps : inditex.initGoogleMaps;

                        inditex.getCoords = _this.isBaidu ?
                            inditex.getBaiduCoords : inditex.getGoogleCoords;

                        inditex.populateMap = _this.isBaidu ?
                            populateBaiduMaps : populateGMaps;

                        inditex.focusMark = _this.isBaidu ? focusBaiduMark : focusGMapMark;

                        if (_this.searchType === joyr.constants.shippingMethods.ITXDROPPOINT) {
                            _this.getDroppointStates();
                        }
                        if (ItxScreenSizeSvc.is('xs,sm')) {
                            _this.ItxLoaderFct.hide();
                            init().done(function () {
                                // FIX US MOBILE
                                if (navigator.geolocation && !_this.storeIdByParams && inditex.iStoreId == '34009527' ) {
                                    locationByGeo('firstLoad', true, null, function () {
                                        locationByIp('firstLoad', true);
                                    });
                                }
                            });
                        } else {
                            init().done(function () {
                                if (navigator.geolocation && !_this.storeIdByParams) {
                                    locationByGeo('firstLoad', true, null, function () {
                                        locationByIp('firstLoad', true);
                                    });
                                } else {
                                    locationByIp('viewDetailStoreEmail', !_this.storeIdByParams);
                                }

                                $scope.$watch(function () { return _this.map.iMarkers.length },
                                    function (newValue, oldValue) {
                                        updateMarkerCluster();
                                    }
                                );

                                $timeout(function () {
                                    if (!_this.mapsLoadedOk) {
                                        ItxLoaderFct.show();
                                        if (navigator.geolocation) {
                                            locationByGeo('timeout', false, null, function () {
                                                locationByIp('timeout', false);
                                            });
                                        } else {
                                            locationByIp('timeout', false);
                                        }
                                    }
                                }, 5000);
                            });
                        }
                    });
                });
            });
        };

        /**
         * @ngdoc method
         * @name result
         * @methodOf  common.store.component:ItxStoreLocator
         * @description
         * Show the quantity of stores where item is available
        */    
        _this.result=function(){
            return _this.text.result + _this.storeList.length;
        }

        _this.showGenericHours=function(store){
            return (!ItxStoreLocatorSvc.existsOpeningHours(store) && store.genericOpeningHours && store.genericOpeningHours.length>1);
        }


        _this.getStoreStatusKey = function (storeId) {
            var elementIndex;
            var found = _.find(_this.storeState, function (arrElement, index) {
                var foundElement = _.find(arrElement.IDS, function (element) {
                    return element == parseInt(storeId);
                });
                if (foundElement) {
                    elementIndex = index;
                }
                return foundElement;
            });
            if (found) {
                _this.storeStateKey = _this.storeStateKeyValue[elementIndex];
                _this.storeStateColor = {
                    'color': found.COLOR,
                    'font-weight': 'bold'
                };
                _this.storeStateDotColor = {
                    'background-color': found.COLOR
                };
                return true;
            }
        };

        _this.existsOpeningHours=function(store){
            return ItxStoreLocatorSvc.existsOpeningHours(store);
        }
        /**
         * @ngdoc method
         * @name toggleFavouriteStore
         * @methodOf  common.store.component:ItxStoreLocator
         * @description
         * Add or delete store from user's favourite store list 
         * calling {@link common.store.service:FavouriteStoreService#toggleFavourite toggleFavourite}
        */  
        _this.toggleFavouriteStore = function (store, $event) {
            var favStore = store ? store : _this.selectedStore;

            $event.stopPropagation();
            $event.preventDefault();

            FavouriteStoreService.toggleFavourite(favStore)
            .then(function(isFavourite){
                favStore.isFavourite = isFavourite;
            });
        };

        _this.filterFavourites = function (store) { 
            return store && store.isFavourite === _this.showFavourites;
        };

        _this.getFavourites =function (){
            return FavouriteStoreService.getFavourites();
        }

        _this.myLocation = function () {
            _this.stores = [];
            imLocatorService.searchNearbyStores(_this.imIsDropPoint);
            if (navigator.geolocation) {
                locationByGeo('myLocation', true, null, function () {
                    locationByIp('myLocation', true);
                });
            } else {
                locationByIp('myLocation', true);
            }
        };

        _this.confirmStore = function (store) {
            _this.onSelectStore({ store: store });
            _this.closeDialog();
        };

        _this.search = function (searchTerm) {
            _this.selectedStore = null;
            _this.stores = [];
            _this.searchByUser = true;
            
            if(!_this.storeState){
                _getStoreStatusProperties();
            }
            
            if (_this.mapsLoadedOk) {
                _this.mapsLoadedOk = false;
                inditex.getCoords(inditex.iCountryCode, searchTerm, function (result) {
                    _this.mapsLoadedOk = true;
                    if (result) {
                        var latitude = !_this.isBaidu ? result.geometry.location.lat() : result.lat,
                            longitude = !_this.isBaidu ? result.geometry.location.lng() : result.lng;

                        searchPoints(latitude, longitude, null, searchTerm);
                    } else {
                        searchPoints(0, 0, null, searchTerm);
                    }
                });
            } else {
                if (navigator.geolocation) {
                    locationByGeo('search', false, searchTerm, function () {
                        locationByIp('search', false, searchTerm);
                    });
                } else {
                    locationByIp('search', false, searchTerm);
                }

                ItxUtilsFct.hideKeyboard('input[name=search-store]');
            }
            
            // IMAnalytics evento localizar_tiendas
            imLocatorService.searchStore(searchTerm, _this.imIsDropPoint);
        };

        _this.getTextTimeDelivery = function (store) {
            var str = ItxTranslateSvc.translate('valor.' + store.id, _this.deliveryTimeStore);
            if (str.indexOf('???') < 0) {
                return str;
            } else {
                return null;
            }
        }

        _this.getRelatedInfo = function (store) {
            var relatedInfo = '';
            if (store.sizeStocks) {
                _.each(store.sizeStocks, function (size, index, elements) {
                    relatedInfo += size.originalSize.name +
                        (index === elements.length - 1 ? '' : ' - ');
                });
            } else {
                if (store.sections) {
                    var secs = store.sections.split(',');
                    _.each(secs, function (sec, index, elements) {
                        relatedInfo += ItxTranslateSvc.translate('ItxStoreLocatorView.sections.' + sec) +
                            (index === elements.length - 1 ? '' : ' - ');
                    });
                }else{
                    if(store.street){
                        relatedInfo = store.street;
                    }
                }
            }
            return relatedInfo;

        };

        _this.selectStore = function (store, $event, fromMap) {
            //La tienda se encuentra en aeropuerto.
            if(store.idStoreType === 5) {
                    _openModalAirport(store, $event, fromMap);
            } else {
                _this.setSelectedStore(store, $event, fromMap);
            }

        };

        _this.setSelectedStore = function(store, $event, fromMap) {
            if (store) {

                /**
                 * IMAnalytics evento desplegar_lista
                **/
                imLocatorService.clickStore(store, $event, _this.imIsDropPoint);

                if (ItxStoreLocatorSvc.getStep !== 'map') {
                    ItxStoreLocatorSvc.setStep('map');
                }
                _this.selectedStore = store;
                var index = _.findIndex(_this.stores, function (st) { return st.id === store.id; });
                // Fix map coordinates US
                if(index === -1 && inditex.iStoreId == '34009527'){
                    _this.map.iMap.panTo(new google.maps.LatLng(  _this.selectedStore.latitude , _this.selectedStore.longitude  ));
                    _this.map.iMap.setZoom(14);
                }
                else{
                    inditex.focusMark(index, _this);
                    setTimeout(function () {
                        inditex.focusMark(index, _this);
                    }, 500);
                }
            } else {
                inditex.focusMark(-1, _this);
            }
            if (_this.isDroppointSearch()) {
                _this.selectedStore.timeTable = _this.ItxStoreLocatorSvc.getTimeTable(_this.selectedStore);
            }
            _this.selectedStore = store;
            if (fromMap) {
                $timeout(function () {
                    _this.scrollToSelected(store);
                }, 200);
            }
        }

        _this.scrollToSelected = function (store) {
            if (store) {

                _this.showFavourites = store.isFavourite;

                // If storelist is paged, show page where store selected is in
                if (_this.visibleStoreCount > 0) {
                    var storeIndex = _.findIndex(_this.storeList, function (s) { return s.id === store.id; });

                    if ((storeIndex + 1) > _this.visibleStoreCount) {
                        _this.visibleStoreCount *= Math.ceil((storeIndex + 1) / _this.visibleStoreCount);
                    }
                }

                $timeout(function () {
                    var _scrollTop = 0;
                    $.each($('.checkout-list.store-list li'), function (key, value) {
                        if ($(this).attr('id') === store.id) {
                            return false;
                        }
                        _scrollTop += $(this).outerHeight();
                    });

                    $('.checkout-list.store-list').animate({
                        scrollTop: _scrollTop
                    }, 500);
                });

            }
        };

        _this.selectStoreByIndex = function (index) {
            _this.selectStore(_this.stores[index]);
        };

        _this.redrawMap = function () {
            $timeout(function () {
                if (!_this.isBaidu) {
                    google.maps.event.trigger(_this.map.iMap, 'resize');
                    refreshFitBounds();
                    if(_this.selectedStore){
                        _this.selectStore(_this.selectedStore, null, true);
                    }    
                }
                else {
                    _this.map = reInitBaiduMap();
                    if (!_this.isDroppointSearch()) {
                        map.iMap.addEventListener(boundsChanged);
                        map.iMap.addEventListener('zoomend', zoomChanged);
                    }
                    _this.stores = [];
                    _this.storeMap = {};
                    inditex.populateMap(_this.storeList)
                        .done(function () {
                            if (_this.selectedStore) {
                                var index = _.findIndex(_this.stores, function (st) { return st.id === _this.selectedStore.id; });
                                if(_this.map.iMarkers[index]){
                                    _this.map.iMarkers[index].isSelected = true;
                                }
                                if (index > -1) {
                                    inditex.focusMark(index, _this);
                                }

                            }
                        });
                }
                
            });
        };

        $scope.$watch(
            function () {
                return ItxStoreLocatorSvc.getStep();
            },
            function (newVal) {
                if (newVal === 'map') {
                    _this.redrawMap();
                }
            }
        );

        _this.getDroppointStates = function () {
            logger.log('GetDroppointStates ');

            var action = {
                action: 'bam:dropPointState',
                params: {
                    storeId: inditex.iStoreId,
                    countryCode: inditex.iCountryCode,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                _this.states = processArrayCombo(data[0].states);
                $scope.$digest();
            });
        };

        _this.showSearch = function () {
            if (_this.storesCountry.length < 10) {
                return true;//cambiar a false para ocultar el buscador cuando tenga menos de 10 tiendas 
            } else {
                return true;
            }
        };
        /**
         * Get a list of municipalities in a state in which to search for drop points. Currently, this only works in Mexico.
         * @param {string} [countryCode='MX'] - The code of the country. If not included Mexico will be assumed.
         * @param {string} stateName - The name of the state.
         */
        _this.getDroppointMunicipalities = function () {
            logger.log('GetDroppointMunicipalities ');

            var action = {
                action: 'bam:dropPointMunicipality',
                params: {
                    storeId: inditex.iStoreId,
                    countryCode: inditex.iCountryCode,
                    state: this.stateName,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                _this.municipalities = processArrayCombo(data[0].municipalities);
                $scope.$digest();
            });
        };
        /**
         * Get a list of colonies in a municipality in which to search for drop points. Currently, this only works
         *  in Mexico.
         * @param {string} [countryCode='MX'] - The code of the country. If not included Mexico will be assumed.
         * @param {string} stateName - The name of the state.
         * @param {string} municipalityName - The name of the municipality.
         */
        _this.getDroppointColonies = function () {
            logger.log('getDroppointColonies ');

            var action = {
                action: 'bam:dropPointColony',
                params: {
                    storeId: inditex.iStoreId,
                    countryCode: inditex.iCountryCode,
                    state: this.stateName,
                    municipality: _this.municipalityName,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                _this.colonies = processArrayCombo(data[0].colonies);
                $scope.$digest();
            });
        };

        _this.xRestGetItxDropPoints = function () {
            rest.xRestGetItxDropPoints(countryCode, postalCode, stateName, municipalityName, colonyName).
                done(function (droppoints) {
                    _this.stores = droppoints;
                    $scope.$digest();
                });
        };

        _this.onSelectState = function (item) {
            _this.stateName = item.name;
            _this.municipalityName = null;
            _this.municipalities = null;
            _this.colonyName = null;
            _this.colonies = null;
            _this.getDroppointMunicipalities();
        };

        _this.onSelectMunicipality = function (item) {
            _this.municipalityName = item.name;
            _this.colonyName = null;
            _this.colonies = null;
            _this.getDroppointColonies();
        };

        _this.onSelectColony = function (item) {
            _this.colonyName = item.name;
            _this.search();
        };

        

        _this.showMore = function () {
            _this.visibleStoreCount += _this.maxStoreCount;
        }

        function init() {
            for (var i = 0; i < inditex.iStoreJSON.configurations.length; i++) {
                var conf = inditex.iStoreJSON.configurations[i];
                if (conf.parametro === 'dropPointParameters' && conf.valor && conf.valor.length) {
                    _this.useNewDroppointSearch = true;
                    break;
                }
            }
            return new joyr.Promise(function (resolve) {
                inditex.initMaps('map', inditex.iCountryCode, _this.isBaidu ? '北京' : '', function (map) {
                    _this.mapsLoadedOk = true;
                    _this.map = map;
                    inditex.getXconfiguracionValue('MAPS_MIN_ZOOM', function (response, value) {
                        if (response === 1 && value) {
                            _this.minZoom = parseInt(value);
                        }
                    });
                    inditex.getXconfiguracionValue('MAPS_ZOOM_ICONS_CHANGE', function (response, value) {
                        if (response === 1 && value) {
                            _this.iconChangeZoom = parseInt(value);
                        }
                    });
                    inditex.getXconfiguracionValue('STORELOCATOR_MAX_STORE_COUNT', function (response, value) {
                        if (response === 1 && value) {
                            _this.maxStoreCount = parseInt(value);
                        }
                        _this.visibleStoreCount = _this.isDroppointSearch ? 1000000 : _this.maxStoreCount;
                    });
                    if (!_this.isBaidu) {
                        map.iMap.mapTypes.set('graytone', new google.maps.StyledMapType([{
                            featureType: 'all',
                            elementType: 'all',
                            stylers: [{
                                saturation: -100
                            }]
                        }], {
                                map: map.iMap,
                                name: 'graytone'
                            }));
                        map.iMap.setMapTypeId('graytone');
                        if ($('html').hasClass('ie8')) {
                            map.iMap.set('mapTypeControl', false);
                        }
                        map.iMap.setZoom(_this.iconChangeZoom);
                        // set listeners
                        map.iMap.addListener('dragend', boundsChanged);
                        map.iMap.addListener('zoom_changed', boundsChanged);
                        if (!_this.isDroppointSearch()) {
                            map.iMap.addListener('zoom_changed', zoomChanged);
                            map.iMap.setOptions({ minZoom: _this.minZoom });
                        }
                    } else if (!_this.isDroppointSearch()) {
                        map.iMap.addEventListener('dragend', boundsChanged);
                        map.iMap.addEventListener('zoomend', zoomChanged);
                    }

                    fillGMapStoreList();

                    resolve();
                });
            });
        }

        function searchPoints(latitude, longitude, store, zipCode, withoutDistance, action) {
            _this.showResults = false;
            if (_this.searchType === 'store' || !_this.searchType) {
                if (_this.showSearchBar === false) {
                    return getStoresList(action);
                } else {
                    return searchStores(latitude, longitude, store, withoutDistance, false);
                }
            } else {
                inditex.getXconfiguracionValue('DROP_POINT_SERVICE_PROVIDER', function (response, value) {
                    inditex.dropPointServiceProvider = value;
                    if (inditex.iCountryCode === 'ES' || inditex.dropPointServiceProvider === 'CHRONOPOST' || _this.useNewDroppointSearch || inditex.dropPointServiceProvider === 'ROYAL_MAIL') {
                        if ((inditex.dropPointServiceProvider === 'CHRONOPOST' || inditex.dropPointServiceProvider === 'ROYAL_MAIL') && !zipCode) {
                            zipCode = '0';
                        }
                        return searchDroppoint(latitude, longitude, zipCode || undefined, withoutDistance);
                    } else {
                        return searchDroppoint(null, null, zipCode || '0', withoutDistance);
                    }
                });
            }
        }

        function searchDroppoint(latitude, longitude, searchTerm, withoutDistance) {
            logger.log('SearchDroppoint ', latitude, longitude, searchTerm, withoutDistance);
            if (latitude === 0 && longitude === 0) {
                return;
            }
            ItxLoaderFct.show();
            $scope.$apply();
            var getDropoints = joyr.rest.xRestGetDroppoints;
            switch (_this.searchType) {
                case joyr.constants.shippingMethods.DROPPOINT:
                    if (_this.useNewDroppointSearch) {
                        var params = {
                            'countryCode': inditex.iCountryCode,
                            'postalCode': searchTerm,
                            'city': searchTerm,
                            'latitude': latitude,
                            'longitude': longitude
                        };
                        joyr.rest.xRestGetDroppointList(params).
                            done(function (droppoints) {
                                processDroppointSearch(droppoints, latitude, longitude, withoutDistance);
                            });
                    } else {
                        joyr.rest.xRestGetDroppoints(inditex.iCountryCode, searchTerm, searchTerm, latitude, longitude)
                            .done(function (droppoints) {
                                processDroppointSearch(droppoints, latitude, longitude, withoutDistance);
                            });
                    }
                    break;
                case joyr.constants.shippingMethods.DROPBOX:
                    if (searchTerm) {
                        if (_this.useNewDroppointSearch) {
                            var params = {
                                'countryCode': inditex.iCountryCode,
                                'postalCode': searchTerm,
                                'city': searchTerm,
                                'latitude': latitude,
                                'longitude': longitude
                            };
                            joyr.rest.xRestGetDroppointList(params).
                                done(function (droppoints) {
                                    processDroppointSearch(droppoints, latitude, longitude, withoutDistance);
                                });
                        } else {
                            //get the list of Dropboxes / pack stations near a postal code.
                            //returns a list of PackStation objects
                            /**
                             * Get a list of pack stations near a postal code.
                             * @param {string} countryCode - The code of the country in which to search.
                             * @param {string} postalCode - The postal code to use for searching.
                             */
                            var action = {
                                action: 'bam:packStation',
                                params: {
                                    storeId: inditex.iStoreId,
                                    postalCode: searchTerm,
                                    countryCode: inditex.iCountryCode,
                                    languageId: inditex.iLangId
                                }
                            };

                            joyr.rest.xRestExecute([action])
                            .done(function (data) {
                                    processDroppointSearch(data[0].packStations, latitude, longitude, withoutDistance);
                                })
                            .Catch(function (err) {
                                processDroppointSearch([], latitude, longitude, withoutDistance);
                                _openModalMessage({
                                    title: ItxTranslateSvc.translateCms('legacy.customMap_empty'),
                                    message: _this.text.noResults + '. ' + _this.text.searchInputPlaceholder
                                });
                            });
                        }
                    } else {
                        processDroppointSearch([], latitude, longitude, withoutDistance);
                    }
                    break;
                case joyr.constants.shippingMethods.ITXDROPPOINT:
                    joyr.rest.xRestGetItxDropPoints(inditex.iCountryCode, searchTerm, _this.stateName || '', _this.municipalityName || '', _this.colonyName || '').
                        done(function (droppoints) {
                            processDroppointSearch(droppoints, latitude, longitude, withoutDistance);
                        });
                    break;
                default:
                    $scope.$digest();
                    break;
            }
        }

        function processDroppointSearch(droppoints, latitude, longitude, withoutDistance) {
            // Add homeNo to address
            _.map(droppoints, function(dropPoint) {
                dropPoint.street += ' ' + dropPoint.homeNo;
                return dropPoint;
            });
            
            _this.isSearchPristine = false;
            ItxLoaderFct.hide();
            $scope.$apply();
            if (droppoints.length > 0) {
                if (!withoutDistance) {
                    _this.stores = [];
                    _this.storeMap = [];
                    _this.storeList = droppoints.map(function (store) {
                        store.timeTable = _this.ItxStoreLocatorSvc.getTimeTable(store);
                    })
                    inditex.populateMap(droppoints, false, true, { latitude: latitude, longitude: longitude })
                        .done(function () {
                            _this.isSearchPristine = false;
                            //resolve();
                        });
                    $scope.$digest();
                    // /**
                    //  * IMAnalytics pageView de envio - Localizador droppoint
                    //  */
                    if (_this.imListView && angular.element('itx-store-locator > div').length) {
                        imLocatorService.createView(_this.imIsDropPoint, droppoints.length);
                        _this.imListView = false;
                    }
                } else {
                    _this.stores = droppoints;
                    $scope.$digest();
                    // /**
                    //  * IMAnalytics pageView de envio - Localizador droppoint
                    //  */
                    if (_this.imListView && angular.element('itx-store-locator > div').length) {
                        imLocatorService.createView(_this.imIsDropPoint, droppoints.length);
                        _this.imListView = false;
                    }
                }
            } else {
                $scope.$digest();
            }


        }

        function searchStores(latitude, longitude, store, withoutDistance) {
            logger.log('SsearchStores ', latitude, longitude, store, withoutDistance);
            _this._initialSearchDone = false;
            _this.searching = true;
            ItxLoaderFct.show();
            $scope.$apply();
            return new joyr.Promise(function (resolve) {
                joyr.rest.xRestGetPhysicalStores({
                    favouriteStores: true,
                    closerStores: true,
                    lastUserStores: true,
                    receiveEcommerce: true,
                    countryCode: inditex.iCountryCode,
                    min: _this.minStoreSearchStore,
                    radioMax: _this.radiusSearchStore,
                    latitude: latitude,
                    longitude: longitude,
                    showBlockedMaxPackage: true
                })
                    .done(function (stores) {
                        
                        _this.favStores = stores.favouriteStores;
                        // after a search, clear map and erase stores list and stores map
                        _this.stores = [];
                        _this.storeMap = {};
                        if(_this.map){
                            _this.map.clear();
                        }
                        _this.visibleStoreCount = _this.maxStoreCount;
                        FavouriteStoreService.setFavourites(stores.favouriteStores.length);
                        var storesConcat = stores.favouriteStores.concat(stores.closerStores)
                            .concat(stores.lastUsedStores);
                        if (store) {
                            storesConcat.unshift(store);
                        }
                        if (storesConcat.length > 0) {
                            if (_this.selectedSizes) {
                                _this.candidateStores = storesConcat;
                                _this.stores = [];
                                joyr.booking.utils.getStoresByPartNumber(_this.candidateStores, _this.selectedSizes).
                                    done(function (stores) {
                                        $scope.$digest();
                                        inditex.populateMap(stores)
                                            .done(function () {
                                                resolve();
                                            });
                                    });
                            }
                            else {
                                inditex.populateMap(storesConcat, false, true, { latitude: latitude, longitude: longitude })
                                    .done(function () {
                                        resolve();
                                    });
                            }
                            $scope.$digest();
                            // /**
                            //  * IMAnalytics pageView de envio - Localizador tienda
                            //  */
                            if (_this.imListView && angular.element('itx-store-locator > div').length) {
                                imLocatorService.createView(_this.imIsDropPoint, stores.closerStores.length);
                                _this.imListView = false;
                            }
                        } else {
                            inditex.populateMap();
                            $scope.$digest();
                        }
                        _this._initialSearchDone = true;
                    })
                    .Finally(function () {
                        _this.isSearchPristine = false;
                        ItxLoaderFct.hide();
                        $scope.$apply();
                    });
            });
        }

        function recursiveDistance(stores, initRadius, increment, maxRadius) {
            if (initRadius >= maxRadius) {
                return stores;
            }
            var filteredStores = _.filter(stores, function (store) {
                return parseFloat(store.parsedDistance.toString()) <= initRadius;
            });
            if (filteredStores.length <= 0) {
                return recursiveDistance(stores, initRadius * increment, increment, maxRadius);
            } else {
                return filteredStores;
            }
        }

        function filterStoresByDistance(stores, coords) {
            return new joyr.Promise(function (resolve) {
                // ==== MDECOMM-16708 ==== Quitar Distance Matrix de Google //
                // if (coords) {
                    // ItxStoreLocatorSvc.getDistance([coords], stores).done(function (distances) {
                        // if (distances && distances.length > 0) {
                        //     var store = null;
                        //     for (var i = 0; i < distances[0].length; i++) {
                        //         store = stores[i];
                        //         store.parsedDistance = parseFloat(distances[0][i].replace(/,/g, '.'));
                        //     }
                        // }
                        // stores = recursiveDistance(stores, 10, 2, _this.radiusSearchStore);
                        // resolve(stores);
                    // });
                // } else {
                    resolve(stores);
                // }
            });
        }

        function getStoresList(action) {
            logger.log('GetStoresList ', action);
            // after a search, clear map and erase stores list and stores map
            _this.stores = [];
            _this.storeMap = {};
            if(_this.map){
            _this.map.clear();
            }   
           
            _this.visibleStoreCount = _this.maxStoreCount;
            _this._initialSearchDone = false;

            ItxLoaderFct.show();
            
            return new joyr.Promise(function (resolve) {
                joyr.rest.xRestGetPhysicalStoresByCountry().done(function (stores) {
                    _this._initialSearchDone = true;
                    // ==== MDECOMM-16708 ==== Quitar Distance Matrix de Google //
                    // ItxStoreLocatorSvc.getDistance([{ latitude: _this.myLocation.latitude, longitude: _this.myLocation.longitude }],
                    //     stores)
                    //     .done(function (distances) {
                            // if (distances && distances.length > 0) {
                            //     var store = null;
                            //     for (var i = 0; i < distances[0].length; i++) {
                            //         store = stores[i];
                                    
                            //         store.distance = distances[0][i];
                            //         if (stores.favouriteStores) {
                            //             var isFavourite = stores.favouriteStores.some(function (favouriteStore) {
                            //                 return favouriteStore.id == store.id;
                            //             });
                            //         }
                            //         store.isFavourite = isFavourite;
                            //     }
                            // }

                            inditex.populateMap(stores.stores)
                                .done(function () {
                                    resolve();
                                    $scope.$digest();
                                });
                            // /**
                            //  * IMAnalytics pageView de envio - Localizador tienda
                            //  */
                            if(!stores.closerStores){
                                stores.closerStores = [];
                            }
                            var storeLocatorDiv = angular.element('itx-store-locator > div');
                            if (_this.imListView && storeLocatorDiv && storeLocatorDiv.length) {
                                imLocatorService.createView(_this.imIsDropPoint, stores.closerStores.length);
                                _this.imListView = false;
                            }
                        // })
                        // .Finally(function () {
                            _this.isSearchPristine = false;

                            // FIX PARA US - Seteamos los stores de la primera peticion de posicion
                            if(inditex.iStoreId == '34009527' && action === 'firstLoad' && stores && stores.stores.length>0){
                                _this.storeList = setFavStores(stores.stores);
                            }

                            ItxLoaderFct.hide();
                            $scope.$apply();
                        // });
                });
            });
        }

        function populateBaiduMaps(stores, isAdding) {
            return new joyr.Promise(function (resolve) {
                if (searchType(_this) !== 'store') {
                    _this.map.clear();
                }
                var promises = [];
                var bounds = new BMap.Bounds();

                window.map = _this.map;
                var _stores = [];
                _.each(stores, function (store) {
                    if (_this.storeMap[store.id]) {
                        return;
                    }
                    _this.stores.push(store);
                    _stores.push(store);
                    _this.storeMap[store.id] = store;
                    promises.push(ItxStoreLocatorSvc.syncTranslateGoogleToBaiduCoords(store.longitude, store.latitude));
                });
                if (!_stores.length) {
                    // no need to calculate anything, so fill the list immediately
                    fillBaiduMapStoreList();
                    $scope.$digest();
                }
                joyr.Promise.all(promises)
                    .done(function (results) {
                        // ==== MDECOMM-16708 ==== Quitar Distance Matrix de Google //
                        // ItxStoreLocatorSvc.getDistance([{ latitude: _this.myLocation.latitude, longitude: _this.myLocation.longitude }],
                        //     _stores)
                        //     .done(function (distances) {
                                // if (distances && distances.length > 0) {
                                //     var store = null;
                                //     for (var i = 0; i < distances[0].length; i++) {
                                //         store = _stores[i];
                                //         store.distance = distances[0][i];
                                //     }
                                // }
                                var initialIndex = _this.map.iMarkers.length;
                                var index = 0;
                                var size = _this.useNormalIcons ? new BMap.Size(_this.baiduMarkerSize, _this.baiduMarkerSize) :
                                    new BMap.Size(_this.baiduMarkerSizeSmall, _this.baiduMarkerSizeSmall);
                                _.each(results, function (point, index) {
                                    var store = _stores[index];
                                    _this.map.addMark(initialIndex + index, point.lat, point.lng, null, function () {
                                        _this.selectStore(store, null, true);
                                        $scope.$digest();
                                    });
                                    if (index === 0) {
                                        bounds = new BMap.Bounds();
                                    }
                                    var marker = _this.map.iMarkers[initialIndex + index];
                                    marker.store = store;
                                    marker.setIcon(
                                        new BMap.Icon(getMarkerIcon(store, false), size));
                                    if (!isAdding) {
                                        bounds.extend(_this.map.iMarkers[index].getPosition());
                                    }
                                });
                                if (!isAdding) {
                                    var boundPoints = new Array(bounds.getNorthEast(), bounds.getSouthWest());
                                    _this.map.iMap.setViewport(boundPoints);
                                    if (_this.map.iMap.getZoom() > 17) {
                                        _this.map.iMap.setZoom(17);
                                    }
                                }
                                fillBaiduMapStoreList();
                                $scope.$digest();
                                resolve();
                            // });
                    });
            });
        }

        function focusBaiduMark(index, _this) {
            var size = _this.useNormalIcons ? new BMap.Size(_this.baiduMarkerSize, _this.baiduMarkerSize) :
                new BMap.Size(_this.baiduMarkerSizeSmall, _this.baiduMarkerSizeSmall);
            _.each(_this.map.iMarkers, function (marker, i) {
                if (index === i) {
                    marker.setIcon(new BMap.Icon(
                        getMarkerIcon(marker.store, true), size));
                    _this.map.iMap.panTo(marker.getPosition());
                }
                else {
                    marker.setIcon(new BMap.Icon(
                        getMarkerIcon(marker.store, false), size));
                }
            });

        }

        function fillBaiduMapStoreList() {
            var bounds = _this.map.iMap.getBounds();
            _this.storeList = [];
            for (var i = 0; i < _this.map.iMarkers.length; i++) {
                var marker = _this.map.iMarkers[i];
                var store = marker.store;
                if (bounds.containsPoint(marker.getPosition()) || ItxStoreLocatorSvc.getStep !== 'map') {
                    _this.storeList.push(store);
                }
            }
            _this.storeList = setFavStores(_this.storeList);
        }

        function getHtmlTextTooltip(store) {
            var str = ItxTranslateSvc.translate('valor.' + store.id, _this.deliveryTimeStore);
            if (str.indexOf('???') < 0) {
                return '<div>' + str + '</div>';
            } else {
                return null;
            }
        }

        function populateGMaps(stores, isAdding, filterStores, coords) {
            //_this.map.iMarkers = []
            stores = stores || [];
            return new joyr.Promise(function (resolve) {
                // if(!_this.map){
                //     return resolve();
                // }
                if (searchType(_this) !== 'store') {
                    _this.map.clear();
                }
                if ((!stores || !stores.length) && !isAdding) {
                    _this.map.iMap.setCenter(new google.maps.LatLng(_this.myLocation.latitude, _this.myLocation.longitude));
                }
                window.map = _this.map;
                var markerBounds = _this.map.iMap.getBounds();
                filterStoresByDistance(stores, coords).done(function (filteredStores) {

                    var _stores = [];
                    _this.filteredStoresByDistance = filteredStores;
                    _.each(stores, function (store) {
                        if (_this.storeMap[store.id]) {
                            return;
                        }
                        _this.stores.push(store);
                        _stores.push(store);
                        _this.storeMap[store.id] = store;
                    });
                    _stores = setFavStores(_stores);
                    if (!_stores.length) {
                        // no need to calculate anything, so fill the list immediately
                        fillGMapStoreList();
                        $scope.$digest();
                    }
                    // ==== MDECOMM-16708 ==== Quitar Distance Matrix de Google //
                    // ItxStoreLocatorSvc.getDistance([{ latitude: _this.myLocation.latitude, longitude: _this.myLocation.longitude }], _stores)
                    //     .done(function (distances) {
                            // if (distances && distances.length > 0) {
                            //     var store = null;
                            //     for (var i = 0; i < distances[0].length; i++) {
                            //         store = _stores[i];
                                    
                            //         store.distance = distances[0][i];
                            //     }
                            // }
                            var initialIndex = _this.map.iMarkers.length;
                            var index = 0;
                            _.each(_stores, function (store) {

                             


                                var htmlText = getHtmlTextTooltip(store);
                                _this.map.addMark(initialIndex + index, store.latitude, store.longitude, htmlText, function () {
                                    _this.selectStore(store, null, true);
                                    $scope.$digest();
                                });
                                // ==== MDECOMM-16708 ==== Quitar Distance Matrix de Google //
                                // if (!store.distance || store.distance === '-') {
                                //     if (_this.myLocation.latitude && _this.myLocation.longitude) {
                                //         store.distance = computeDistance(_this.myLocation.latitude, _this.myLocation.longitude, store.latitude, store.longitude).toFixed(2) + ' km';
                                //     } else {
                                //         store.distance = '';
                                //     }
                                // }
                                if (!htmlText) {
                                    _this.map.iWindows[initialIndex + index].open = function () { };
                                } else {
                                    _this.map.iWindows[initialIndex + index].setOptions({
                                        content: htmlText,
                                        disableAutoPan: true
                                    });
                                }

                                var marker = _this.map.iMarkers[initialIndex + index];
                                marker.set('store', store);
                                marker.icon = getMarkerIcon(store, false);
                                if (!isAdding) {
                                    if (index === 0) {
                                        markerBounds = new google.maps.LatLngBounds();
                                    }

                                    if(!_this.isInitialSearch) {
                                        if (_this.filteredStoresByDistance && _.some(_this.filteredStoresByDistance, { 'id': store.id })) {
                                            markerBounds.extend(new google.maps.LatLng(store.latitude, store.longitude));
                                        }
                                    } else {
                                        markerBounds.extend(new google.maps.LatLng(store.latitude, store.longitude));
                                    }
                                }
                                index++;
                            });
                            if(_this.isInitialSearch) {
                                _this.isInitialSearch = false;
                            }
                            if (!isAdding && !ItxScreenSizeSvc.is('xs,sm')) {
                                _this.searching = true;
                                _this.map.iMap.fitBounds(markerBounds);
                            }
                            
                            // find the stores currently visible in the map and show theme
                            fillGMapStoreList();
                            $scope.$digest();
                            resolve();
                        // });

                }).Catch(function (error) {
                    logger.log(error);
                });
            });
        }

        function focusGMapMark(index, _this) {
            _.each(_this.map.iMarkers, function (marker, i) {
                if (index === i) {
                    marker.setIcon(
                        getMarkerIcon(marker.get('store'), true));
                    marker.setOptions({ zIndex: 9999 });
                    _this.map.iMap.panTo(marker.getPosition());
                    if (isClustered(marker)) {
                        _this.map.iMap.setZoom(16);
                    }

                }
                else {
                    marker.setOptions({ zIndex: 1 });
                    marker.setIcon(
                        getMarkerIcon(marker.get('store'), false));
                }
            });
            if (_this.map.iWindows[index]) {
                _this.map.iWindows[index].open(_this.map.iMap, _this.map.iMarkers[index]);
            }

        }

        function getMarkerIcon(store, isSelected) {
            var key = 'marker' + (store.isFavourite ? 'Fav' : '') + (isSelected ? 'On' : 'Off') + (_this.useNormalIcons ? '' : 'Sm');
            return ItxConstants.markerImages[searchType(_this)][key];
        }

        function fillGMapStoreList() {
            if(_this.map){
                var bounds = _this.map.iMap.getBounds();

                if(bounds){
                    _this.storeList = [];
                    for (var i = 0; i < _this.map.iMarkers.length; i++) {
                        var marker = _this.map.iMarkers[i];
                        if (bounds.contains(marker.getPosition()) || ItxStoreLocatorSvc.getStep !== 'map') {
                            _this.storeList.push(marker.get('store'));
                        }
                    }
                    _this.showResults = true;
                }
            }
        }

        function searchType(_this) {
            return _this.searchType || 'store';
        }

        function processArrayCombo(array) {
            return _.sortedUniq(_.map(array, function (item) { return { code: item, name: item } }));
        }

        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        };

        // calculate the distance between two points using the heaversine formula
        function computeDistance(p1lat, p1long, p2lat, p2long) {
            var radius = 6731;
            var dLat = deg2rad(p2lat - p1lat);
            var dLon = deg2rad(p2long - p1long);
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(p1lat)) * Math.cos(deg2rad(p2lat)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2)
                ;
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = radius * c; // Distance in km
            return d;
        };

        function boundsChanged(type) {            
            if (!_this._initialSearchDone || _this.searching) {
                _this.searching = false;
                return;
            }
            if (_this.movingTimer) {
                _this.pendingEvents = true;
                return;
            }
            updateMarkerCluster();
            _this.movingTimer = setTimeout(function () {
                _this.movingTimer = null;
                _this.isBaidu ? _baiduBoundsChanged() : _googleBoundsChanged();
            }, 1000);
        };

        function _googleBoundsChanged() {
            logger.log('GoogleBoundsChanged ');
            _this.pendingEvents = false;
            var bounds = _this.map.iMap.getBounds();
            var sw = bounds.getSouthWest();
            var ne = bounds.getNorthEast();
            var center = bounds.getCenter();
            var radius = Math.max(50, Math.ceil(computeDistance(sw.lat(), sw.lng(), ne.lat(), ne.lng()) / 1.75));
            joyr.rest.xRestGetPhysicalStores({
                favouriteStores: true,
                closerStores: true,
                receiveEcommerce: _this.receiveEcommerce || false,
                //countryCode: _this.receiveEcommerce ? inditex.iCountryCode : undefined,
                min: 1000,
                radioMax: radius,
                latitude: center.lat(),
                longitude: center.lng(),
                showBlockedMaxPackage: _this.showBlockedMaxPackage || false,
                countryCode: _this.countryCode
            }).done(function (stores) {
                if (_this.selectedSizes) {
                    joyr.booking.utils.getStoresByPartNumber(stores, _this.selectedSizes).
                        done(function (stockStores) {
                            $scope.$digest();
                            inditex.populateMap(stockStores, true)
                                .done(function () {
                                    resolve();
                                });
                        });
                } else {
                    inditex.populateMap(stores.closerStores, true);
                }
            });
        }

        function _baiduBoundsChanged() {
            logger.log('BaiduBoundsChanged ');
            _this.pendingEvents = false;
            var bounds = _this.map.iMap.getBounds();
            var sw = bounds.getSouthWest();
            var ne = bounds.getNorthEast();
            var center = bounds.getCenter();
            var radius = Math.max(50, Math.ceil(computeDistance(sw.lat, sw.lng, ne.lat, ne.lng) / 1.75));
            joyr.rest.xRestGetPhysicalStores({
                closerStores: true,
                receiveEcommerce: _this.receiveEcommerce || false,
                //countryCode: _this.receiveEcommerce ? inditex.iCountryCode : undefined,
                min: 1000,
                radioMax: radius,
                latitude: center.lat,
                longitude: center.lng,
                showBlockedMaxPackage: _this.showBlockedMaxPackage || false,
                countryCode: _this.countryCode
            }).done(function (stores) {
                if (_this.selectedSizes) {
                    joyr.booking.utils.getStoresByPartNumber(stores, _this.selectedSizes).
                        done(function (stockStores) {
                            $scope.$digest();
                            inditex.populateMap(stockStores, true)
                                .done(function () {
                                    resolve();
                                });
                        });
                } else {
                    inditex.populateMap(stores.closerStores, true);
                }
            });
        }

        function zoomChanged() {
            var newZoom = _this.map.iMap.getZoom();
            var useNormalIcons = _this.useNormalIcons;
            if (newZoom < _this.iconChangeZoom && _this.useNormalIcons) {
                _this.useNormalIcons = false;
            } else if (newZoom >= _this.iconChangeZoom && !_this.useNormalIcons) {
                _this.useNormalIcons = true;
            }
            if (useNormalIcons !== _this.useNormalIcons) {
                _this.isBaidu ? changeBaiduMarkerIcons() : changeGMarkerIcons();
            }
        }

        function changeGMarkerIcons() {
            _.each(_this.map.iMarkers, function (marker) {
                var store = marker.get('store');
                marker.setIcon(getMarkerIcon(store, _this.selectedStore && _this.selectedStore.id === store.id));
            });
        }

        function changeBaiduMarkerIcons() {
            var size = _this.useNormalIcons ? new BMap.Size(_this.baiduMarkerSize, _this.baiduMarkerSize) :
                new BMap.Size(_this.baiduMarkerSizeSmall, _this.baiduMarkerSizeSmall);
            _.each(_this.map.iMarkers, function (marker) {
                var store = marker.store;
                marker.setIcon(getMarkerIcon(store, _this.selectedStore && _this.selectedStore.id === store.id), size);
            });
        }

        function locationByIp(action, updateLocation, searchTerm) {
            logger.log('LocationByIp ', action, updateLocation, searchTerm);
            joyr.rest.xGetGeolocation()
                .done(function (data) {
                    if (updateLocation && action != 'viewDetailStoreEmail') {
                        _this.myLocation.longitude = data['long'];
                        _this.myLocation.latitude = data['lat'];
                    }
                    switch (action) {
                        case 'firstLoad':
                            _this.storeId = _this.storeId || _this.storeIdByParams;
                            if (_this.storeId) {
                                joyr.rest.xRestGetPhysicalStore(_this.storeId).
                                    done(function (store) {
                                        searchPoints(data['lat'], data['long'], store, null, false, action)
                                            .done(function () {
                                                _this.selectStore(store);
                                                $scope.$digest();
                                            });
                                    });
                            }
                            else {
                                searchPoints(data['lat'], data['long'], null, null, false, action);
                            }
                            break;

                        case 'viewDetailStoreEmail':
                            _this.storeId = _this.storeId || _this.storeIdByParams;
                            if (_this.storeId) {
                                joyr.rest.xRestGetPhysicalStore(_this.storeId).
                                    done(function (store) {
                                        searchPoints(store.latitude, store.longitude, store)
                                            .done(function () {
                                                _this.selectStore(store);
                                                $scope.$digest();
                                            });
                                    });
                            }
                            else {
                                searchPoints(data['lat'], data['long']);
                            }
                            break;
                        case 'myLocation':
                            searchPoints(data['lat'], data['long'], null, null, false);
                            if (!_this.isBaidu) {
                                if(_this.map){
                                    _this.map.iMap.panTo(new google.maps.LatLng(data['lat'], data['long']));
                                }
                            }
                            else {
                                ItxStoreLocatorSvc.syncTranslateGoogleToBaiduCoords(data['lat'], data['long'])
                                    .done(function (point) {
                                        _this.map.iMap.panTo(point);
                                    });
                            }
                            break;
                        case 'search':
                            searchPoints(data['lat'], data['long'], null, searchTerm, true);
                            break;
                        case 'timeout':
                            searchPoints(data['lat'], data['long'], null, null, true);
                            break;
                    }


                });
        }

        function locationByGeo(action, updateLocation, searchTerm, errorFn) {
            logger.log('LocationByGeo ', action, updateLocation, searchTerm, errorFn);
            if (_this.isMobile === false && _this.isFirefox === true && navigator.permissions) {
                navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                    if (result.state === 'prompt') {
                        errorFn();
                    }
                    result.onchange = function () {
                        if (result.state === 'prompt') {
                            errorFn();
                        }
                    };
                });
            }
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    if (updateLocation) {
                        _this.myLocation.longitude = position.coords.longitude;
                        _this.myLocation.latitude = position.coords.latitude;
                    }
                    switch (action) {
                        case 'firstLoad':
                            _this.storeId = _this.storeId || _this.storeIdByParams;
                            if (_this.storeId) {
                                joyr.rest.xRestGetPhysicalStore(_this.storeId).
                                    done(function (store) {
                                        searchPoints(position.coords.latitude, position.coords.longitude, store)
                                            .done(function () {
                                                _this.selectStore(store);
                                                $scope.$digest();
                                            });
                                    });
                            }
                            else {
                                searchPoints(position.coords.latitude, position.coords.longitude);
                            }
                            break;
                        case 'myLocation':
                            searchPoints(position.coords.latitude, position.coords.longitude, null, null);
                            if (!_this.isBaidu) {
                                _this.map.iMap.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                            }
                            else {
                                ItxStoreLocatorSvc.syncTranslateGoogleToBaiduCoords(position.coords.latitude, position.coords.longitude)
                                    .done(function (point) {
                                        _this.map.iMap.panTo(point);
                                    });
                            }
                            break;
                        case 'search':
                            searchPoints(position.coords.latitude, position.coords.longitude, null, searchTerm, true);
                            break;
                        case 'timeout':
                            searchPoints(position.coords.latitude, position.coords.longitude, null, null, true);
                            break;
                    }
                }, function () {
                    errorFn();
                }
            );
        }

        function setFavStores(stores) {
            var storeList = stores ? stores : _this.storeList;

            for (var i = 0; i < storeList.length; i++) {
                if (_this.favStores) {
                    var isFavourite = _this.favStores.some(function (favouriteStore) {
                        return (favouriteStore.id == storeList[i].id && !favouriteStore.isBlocked);
                    });
                    storeList[i].isFavourite = isFavourite;
                    
                    if (!isFavourite) {
                        _this.allFavourites = false;
                    } 

                } else {
                    storeList[i].isFavourite = false;
                    _this.allFavourites = false;
                }
            }
            _this.showFavourites = _this.allFavourites;
            
            return storeList;
        }

        function updateMarkerCluster() {
            if (!_this.isBaidu) {
                if (_this.markerCluster) {
                    _this.markerCluster.clearMarkers();
                }
                _this.markerCluster = new MarkerClusterer(_this.map.iMap, _this.map.iMarkers,
                    {
                        maxZoom: 15,
                        gridSize: 100,
                        styles: [{
                            url: '/static/itxwebstandard/images/m1.png',
                            width: 53,
                            height: 52,
                            textColor: '#ffffff'
                        },
                        {
                            url: '/static/itxwebstandard/images/m2.png',
                            width: 56,
                            height: 55,
                            textColor: '#ffffff'
                        },
                        {
                            url: '/static/itxwebstandard/images/m3.png',
                            width: 66,
                            height: 65,
                            textColor: '#ffffff'
                        },
                        {
                            url: '/static/itxwebstandard/images/m4.png',
                            width: 78,
                            height: 77,
                            textColor: '#ffffff'
                        },
                        {
                            url: '/static/itxwebstandard/images/m5.png',
                            width: 90,
                            height: 89,
                            textColor: '#ffffff'
                        }]
                    });
            }
        }

        function isClustered(marker) {
            if (_this.markerCluster) {
                var clusters = _this.markerCluster.getClusters();
                for (var i = 0, l = clusters.length; i < l; i++) {
                    for (var j = 0, le = clusters[i].markers_.length; j < le; j++) {
                        if (marker === clusters[i].markers_[j] && clusters[i].clusterIcon_.sums_) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        function reInitBaiduMap() {
            var aCustomIcon = undefined;
            var newMap = {
                iMap: new BMap.Map('map', {
                    mapType: BMAP_NORMAL_MAP
                }),

                iMarkers: [],
                iWindows: [],

                addMark: function (index, latitude, longitude, text, onSuccess) {
                    var self = this;
                    var point = new BMap.Point(longitude, latitude);
                    if ((aCustomIcon == undefined || aCustomIcon == true)) {
                        var customIcon = new BMap.Icon(inditex.getBaiduMapsMarkerUrl(false), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight));
                        self.iMarkers[index] = new BMap.Marker(point, {
                            icon: customIcon
                        });
                    }
                    else {
                        if ((aCustomIcon == false)) {

                            self.iMarkers[index] = new BMap.Marker(point);
                        }
                        else if (typeof aCustomIcon == "string") {
                            var customIcon = new BMap.Icon(inditex.getBaiduMapsMarkerUrlAlt(false, aCustomIcon), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight));
                            self.iMarkers[index] = new BMap.Marker(point, {
                                icon: customIcon
                            });
                        }
                    }
                    if (text && text != "") {
                        self.iWindows[index] = new BMap.InfoWindow(text);
                    }

                    self.iMarkers[index].addEventListener('click', function (e) {
                        self.focusMark(index);
                        if (onSuccess) {
                            onSuccess(index);
                        }
                    });

                    self.iMap.addOverlay(self.iMarkers[index]);

                },

                focusMark: function (index) {
                    var self = this;

                    for (var i = 0; i < self.iMarkers.length; i++) {
                        if (i == index) {
                            if (self.iWindows[i]) {
                                self.iMarkers[i].openInfoWindow(self.iWindows[i]);
                            }
                            if (!self.iMap.getBounds().containsPoint(self.iMarkers[i].getPosition())) {
                                self.iMap.panTo(self.iMarkers[i].getPosition());
                            }
                            if (aCustomIcon == undefined || aCustomIcon == true) {

                                self.iMarkers[i].setIcon(new BMap.Icon(inditex.getBaiduMapsMarkerUrl(true), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight)));
                            }
                            else if (typeof aCustomIcon == "string") {
                                self.iMarkers[i].setIcon(new BMap.Icon(inditex.getBaiduMapsMarkerUrlAlt(true, aCustomIcon), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight)));
                            }
                        } else {
                            self.iMarkers[i].closeInfoWindow();
                            if (aCustomIcon == undefined || aCustomIcon == true) {
                                self.iMarkers[i].setIcon(new BMap.Icon(inditex.getBaiduMapsMarkerUrl(false), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight)));

                            }

                            else if (typeof aCustomIcon == "string") {
                                self.iMarkers[i].setIcon(new BMap.Icon(inditex.getBaiduMapsMarkerUrlAlt(false, aCustomIcon), new BMap.Size(inditex.baiduIconWidth, inditex.baiduIconHeight)));

                            }
                        }
                    }
                },
                clear: function () {
                    var self = this;

                    for (var i = 0; i < self.iWindows.length; i++) {
                        self.iWindows[i].close();
                    }
                    for (var i = 0; i < self.iMarkers.length; i++) {
                        self.iMap.removeOverlay(self.iMarkers[i]);
                    }
                    self.iMarkers.length = 0;
                    self.iWindows.length = 0;
                },
                focus: function () {
                    var self = this;

                    var bounds = new BMap.Bounds();

                    for (var i = 0; i < self.iMarkers.length; i++) {
                        if (self.iMarkers[i]) {
                            bounds.extend(self.iMarkers[i].getPosition());
                        }
                    }
                    var boundPoints = new Array(bounds.getNorthEast(), bounds.getSouthWest());
                    self.iMap.setViewport(boundPoints);
                    if (self.iMap.getZoom() > 17) {
                        self.iMap.setZoom(17);
                    }
                }
            }

            newMap.iMap.enablePinchToZoom();
            newMap.iMap.enableScrollWheelZoom();

            return newMap;
        }

        function refreshFitBounds() {
            if(_this.filteredStoresByDistance && _this.map.iMap) {
                var markerBounds = new google.maps.LatLngBounds();

                _.forEach(_this.filteredStoresByDistance, function(store) {
                    markerBounds.extend(new google.maps.LatLng(store.latitude, store.longitude));
                });

                _this.map.iMap.fitBounds(markerBounds);
            }
        }

        // data = { title:String, message:String }
        function _openModalMessage(data) {
            var modalDialog = ngDialog.open({
                template: [
                        '<div>',
                            '<h3 class="mb-16">{{ngDialogData.model.title}}</h3>',
                            '<p class="gamma">{{ngDialogData.model.message}}</p>',
                        '</div>'
                    ].join(''),
                plain: true,
                showClose: true,
                className: 'ma-dialog ngdialog-theme-plain ma-dialog-packstations',
                data: {
                    model: data
                }
            });
            setTimeout(function() {
                modalDialog.close();
            }, 2500);
        }



    //     <div class="dialog-content">
    //     <h2 class="text" ng-bind-html="::dialogMessageCtrl.title"></h2>
    //     <p class="text gamma" ng-bind-html="::dialogMessageCtrl.message"></p>

    //     <div class="btn-container col-sm-6 ">
    //         <button class="btn btn-primary btn--small btn-block" ng-click="dialogMessageCtrl.onContinue()">{{ 'legacy.continue' | tCms }}</button>	
    //     </div>
    //      </div>

        function _openModalAirport(store, $event, fromMap) {
            if(_this.selectedStore && (_this.selectedStore.id === store.id)) {
                return false;
            }
            if($('.modal-airport').length < 1) {
                var modalDialog = ngDialog.open({
                    template: [
                            '<div class="ma-modal-header"> </div> ',
                            '<div class="ma-modal-body text-center">',
                                '<p class="text gamma">{{ "legacy.storeLocator.airportMessage" | tCms }}</p>',
                            '</div>',
                            '<div class="ma-modal-footer">',
                                '<button class="btn btn-primary btn--small btn-block" ng-click="ngDialogData.onConfirmStore()">{{ "legacy.continue" | tCms }}</button>',
                            '</div>',
                        ].join(''),
                    plain: true,
                    showClose: true,
                    className: 'new-modal ma-modal-xs ngdialog-theme-plain ma-dialog-packstations modal-airport',
                    data: {
                        action:'seleccionar',
                        onConfirmStore:function() {
                            _this.setSelectedStore(store, $event, fromMap);
                            modalDialog.close();
                    }},
                    preCloseCallback: function () {
                        _this.redrawMap();
                        inditex.focusMark(-1, _this);
                    }
                });
            }
        }

        function _getStoreStatusProperties() {
            CmsConfigSvc.getProperty('stores_status_properties')
            .then(function(res){
                if(res){
                    _this.storeState = res;
                }
                _storeTranslates(_this.storeState);
            });
        }

        function _storeTranslates(storeStates) {
            var i = 0;
            _this.storeStateKeyValue = [];
            (function next() {
                storeStates[i] && CmsConfigSvc.getTranslation(storeStates[i++].KEY, [])
                    .then(function(value){
                        _this.storeStateKeyValue.push(value);
                    }).then(next);
            })();
        } 



    }

    angular.module('itxApp.common')
        .component('itxStoreLocator', ItxStoreLocatorCmp);

})(window.itxApp);
// jshint ignore:end